import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import _, { filter, template } from 'lodash';

/*Dialogs*/
// import RunExportSelectDataOverlayDialog from '../../dialogs/runExportSelectDataOverlayDialog';
import SuccessPriceTemplateConfirmation from '../../dialogs/successPriceTemplateConfirmation';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import RunReportDialog from '../../dialogs/runReportDialog';
import {userDetailsForStandardTemplate} from '../../common/LookUpTable';

/*Actions*/
import {
	getSavedExports,
	deletePriceTemplate,
	savePriceTemplates,
	getSavedExportsForStandardTemplate,
	saveTemplateId,
	exportProducts,
	createPriceTemplate,
	setEditTemplatePayload,
	getMessages
} from '../../../redux/actions';

class SavedExports extends Component {

	constructor(props) {
        super(props);
        this.state = {
			confirmationMessage: '',
			errorMessage: '',
			runExportTemplateId: '',

			// showRunExportSelectDataOverlayDialog: false,
			showSuccessPriceTemplateConfirmation: false,
			showRunReportDialog: false,
			showGenericOverlayDialog: false,
            genericDialogHeading: '',
            genericDialogText: '',
			modalButtons: '',
			message:[],
			standardTemplate : [],
			standardTemplateUserSSO : userDetailsForStandardTemplate.ssoId,
            standardTemplateUserAccountNUmber : userDetailsForStandardTemplate.accountNumber
        }
		this.getDemadClassforAgreement = this.getDemadClassforAgreement.bind(this);
    }

	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillMount() {
		const self = this;
		const today = moment();
		self.props.getMessages(`accountNumber=${self.props.state.user.accountDetail.responseObject[0].ACCOUNTNUMBER}`, true, response => {
				if (response.status && response.responseObject) {
					const filteredMessages = response.responseObject.filter(message => {
						const startDate = moment(message.start_date);
						const endDate = moment(message.end_date);
						return startDate <= today <= endDate;
					});
					self.setState({
						message: filteredMessages
					});
				}
			});
	}

	componentDidMount() {
		var self = this;
		let { state } = self.props;

		self.setState({
			errorMessage: ""
		})

		//If there is no existing data available in store,
		//then make service call and get data and then do needful
		if(self.props.getSelectedAccountNumber()) {
			//Here we are fetching standard template
			self.props.getSavedExportsForStandardTemplate("userId="+ self.state.standardTemplateUserSSO +"&accountNumber=" + self.state.standardTemplateUserAccountNUmber, (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				}else{
					self.setState({
						standardTemplate:response.responseObject
					})
				}
			});

		    self.props.getSavedExports("userId="+state.user.userDetails.sso+"&accountNumber=" + self.props.getSelectedAccountNumber(), (response) => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				}
			});
		}
	}

	handleDeleteExports(templateId, event) {
		event.preventDefault();
		var self = this;
		let { state } = self.props;
		self.setState({
			errorMessage: ''
		})
		let payload = _.find(state.exports.priceTemplates.responseObject, ["templateId", templateId]);
		self.props.deletePriceTemplate(payload, (response) => {
			if(response.status) {
				self.setState({
					genericDialogHeading: "Template Deleted",
					genericDialogText: "Selected Template has been deleted successfully.",
					modalButtons: "ok",
					showGenericOverlayDialog: false
				}, () => {
					self.setState({
						showGenericOverlayDialog: true
					})
				});
				var savedPriceTemplates = [];
				state.exports.priceTemplates.responseObject.map((item, index) => {
					//Delete brochure scenario
					if(templateId !== item.templateId) {
						savedPriceTemplates.push(item);
					}
					return null;
				});
				let data = state.exports.priceTemplates;
				data.responseObject = savedPriceTemplates;
				this.props.savePriceTemplates(data);
			} else {
				self.setState({
					errorMessage: response.responseMessage
				})
			}
		});
	}

	handleEditExports(templateId, event) {
		event.preventDefault();
		let { state } = this.props;
		this.props.setEditTemplatePayload(null);
		var payload = _.find(state.exports.priceTemplates.responseObject, ["templateId", templateId]);
		this.props.setEditTemplatePayload(payload);
		browserHistory.push('/price-template/edit');
	}

	handleRunExport(templateId, event) {
		event && event.preventDefault();
		var self = this;
		self.setState({
			showRunReportDialog: true
		})
		self.props.saveTemplateId(templateId);
		
	}

	handleContinueRunReport(childState, selecteDate, event) {
		event && event.preventDefault();
		var self = this;
		let { state } = self.props;
		const { selectedAccount } = state.user;
		const { selectedPriceSource } = self.props.state.user;
		let templateId = state.exports.templateId;
		let data = [...self.state.standardTemplate, ...state.exports.priceTemplates.responseObject];
		var payload = _.find(data, ["templateId", templateId]);
		let quoteType = '';
		payload.accountNumber =  selectedAccount.ACCOUNTNUMBER;
		payload.salesAgreementName = selectedPriceSource.AGREEMENT_NAME;
		payload.emailId = state.user.userDetails.email;
		const selectedAccountsAllPriceSources = this.props.getSalesAgreementList();
		if(selectedPriceSource && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.length > 0) {
			const data = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER === selectedPriceSource.AGREEMENT_NUMBER);
			quoteType = data && data["Quote Type"] ? data["Quote Type"].toLowerCase() : '';			
		}
		if(childState.isTodayPriceChecked){
			payload.todaysPrice = moment().format('MM/DD/YYYY');
			delete payload.futurePrice;
		}else if(childState.isFuturePriceChecked){
			payload.futurePrice = selecteDate && selecteDate.format('MM/DD/YYYY');
			delete payload.todaysPrice;
		}
		const demandClass = this.getDemadClassforAgreement(state.user.selectedPriceSource.AGREEMENT_NUMBER.toString());
		let messageQuoteType = self.state.message && self.state.message.length >0 ? self.state.message[0].message_description : "";
		payload = {
			...payload,
			salesAgreementNumber: state.user.selectedPriceSource.AGREEMENT_NUMBER.toString(),
			demandClass: demandClass,
			message_description: quoteType && quoteType =="n"?messageQuoteType:""
		}
		self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
			payload = {
				...payload,
				topLoadIndicator: resp ? 'Y' : 'N'
			};
			const data = JSON.parse(self.props.state.user.selectedAddress);
			const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
			zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					self.props.exportProducts(payload, `warehouseCode=${resp.agentid}`, response => {
						//Update store with new price template for saved brochure
						window.scrollTo(0, 0);
						if(response.status) {
							self.setState({
								showSuccessPriceTemplateConfirmation: true
							})
						} else {
							self.setState({
								errorMessage: response.responseMessage
							})
						}
					});
				}
			});
		});
	}

	getDemadClassforAgreement(agreementNumber) {
		const self = this;
		const { selectedPriceSource, selectedAccountsAllPriceSources } = self.props.state.user;
		let priceSourceDetails = JSON.parse(JSON.stringify(selectedPriceSource));
		if (agreementNumber) {
			priceSourceDetails = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER.toString() === agreementNumber.toString());
		}
		if (priceSourceDetails && priceSourceDetails["Demand Class"]) {
			return priceSourceDetails["Demand Class"];
		}
	}

	handleCreateNewTemplate(event) {
		event.preventDefault();
		browserHistory.push('/price-template/new');
	}

	handleCopyTemplate(templateId, event) {
		event.preventDefault();
		var self = this;
		let { state } = self.props;
		var payload = _.find(state.exports.priceTemplates.responseObject, ["templateId", templateId]);
		payload = JSON.parse(JSON.stringify(payload));
		//Delete existing template id
		delete payload.templateId;
		//update existing name by adding _copy after name
		payload.templateName += "_copy";
		self.setState({
			errorMessage: '',
			tempPayload: payload
		});
		//Set payload in store, this can be used in call back to update store
		self.props.createPriceTemplate(payload, (response) => {
			if(response.status) {
				self.setState({
					genericDialogHeading: "Template Copied",
					genericDialogText: "Template copied successfully.",
					modalButtons: "ok",
					showGenericOverlayDialog: false
				}, () => {
					self.setState({
						showGenericOverlayDialog: true
					})
				});
				//Update store with newly copied template
				var priceTemplates = state.exports.priceTemplates;
				priceTemplates.responseObject.push(response.responseObject);
				self.props.savePriceTemplates(priceTemplates);
			} else {
				self.setState({
					errorMessage: response.responseMessage
				})
			}
		});
	}

    render() {
		let { user, exports } = this.props.state;
		const selectedAccountsAllPriceSources = this.props.getSalesAgreementList();
		const {selectedPriceSource } = this.props.state.user;
		const {standardTemplate} = this.state;
		const typeOfUser = this.props.state.user && this.props.state.user.userDetails.typeOfUser;
		const salesChannelCode = this.props.state.user && this.props.state.user.selectedAccount && this.props.state.user.selectedAccount.SALESCHANNELCODE;
		let quoteType = '';
		if(selectedPriceSource && selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.length > 0) {
			const data = selectedAccountsAllPriceSources.responseObject.find(item => item.AGREEMENT_NUMBER === selectedPriceSource.AGREEMENT_NUMBER);
			quoteType = data && data["Quote Type"] ? data["Quote Type"].toLowerCase() : '';			
		}
        return (
            <div>
				<h1 className="pageTitle">Export Product & Pricing Information</h1>
				{this.state.message && this.state.message.length >0 && quoteType && quoteType =="n"  ?<h1 className="pageQuoteMessage">{this.state.message[0].message_description}</h1>:""}
				<p>Choose from an existing product and price template below <strong>OR</strong> create a new template.</p>
				<p className="red bold">{this.state.errorMessage}</p>
				<h4 className="bold">{this.state.confirmationMessage}</h4>
				<div className="push">
			        <h2><a onClick={this.handleCreateNewTemplate.bind(this)} href="" className="blueButton">CREATE NEW TEMPLATE</a>{/*user.accountDetail && user.accountDetail.accountName} — {user.accountDetail && user.accountDetail.accountNumber*/}</h2>
					{salesChannelCode == 'RETAIL' && standardTemplate && standardTemplate.length > 0
						?<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
				          	<thead>
					            <tr>
									<th>Standard Templates</th>
									<th>&nbsp;</th>
					            </tr>
				          	</thead>
							<tbody>
								{typeOfUser=='employee'?
								standardTemplate.map((item, index) => {
									return <tr key={index}>
						              	<td>{item.templateName}</td>

										<td className="txt-ctrStnd" style={{paddingRight : '3.7em'}}>
											<a className="blueButton" href="" onClick={this.handleRunExport.bind(this, item.templateId)} style={{fontSize: '0.9em'}}>Run Report</a>
										</td>
						            </tr>
								}) :
								standardTemplate.filter((item)=>(item.templateName=='Retail Promo Planning'))
									.map((item,index)=>{
										return <tr key={index}>
						              	<td>{item.templateName}</td>										
										<td className="txt-ctrStnd" style={{paddingRight : '3.7em'}}>
											<a className="blueButton" href="" onClick={this.handleRunExport.bind(this, item.templateId)} style={{fontSize: '0.9em'}}>Run Report</a>
										</td>
						            </tr>
									})
									}							
				          	</tbody>
				        </table>
						:null
					} 
					{exports.priceTemplates && exports.priceTemplates.responseObject && exports.priceTemplates.responseObject.length > 0
						?<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
				          	<thead>
					            <tr>
									<th>My Templates</th>
									<th>Copy Template</th>
									<th>Template<br/>Created On</th>
									<th>Edit<br/>Template</th>
									<th>Delete<br/>Template</th>
									<th>&nbsp;</th>
					            </tr>
				          	</thead>
							<tbody>
								{exports.priceTemplates.responseObject.map((item, index) => {
									return <tr key={index}>
						              	<td>{item.templateName}</td>
										<td><a href="" onClick={this.handleCopyTemplate.bind(this, item.templateId)}>Copy</a></td>
						              	<td>{item.createdDate}</td>
										{item.templateId
											?<td>
												<a className="editTemplateIcon" href="" onClick={this.handleEditExports.bind(this, item.templateId)}>
													<img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Template" title="Edit Template" />
												</a>
											</td>
											:<td>
												<a className="editTemplateIcon" href="" onClick={this.handleEditExports.bind(this, `${user.accountDetail.accountNumber}-${item.templateName}`)}>
													<img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Template" title="Edit Template" />
												</a>
											</td>
										}
										<td><a className="xMe" href="" onClick={this.handleDeleteExports.bind(this, item.templateId)}>X</a></td>
										<td className="txt-ctr">
											<a className="blueButton" href="" onClick={this.handleRunExport.bind(this, item.templateId)} style={{fontSize: '0.9em'}}>Run Report</a>
										</td>
						            </tr>
								})}
				          	</tbody>
				        </table>
						:null
					}
					{exports.priceTemplates && exports.priceTemplates.responseObject && exports.priceTemplates.responseObject.length === 0
						?<p className="brochureName" colSpan={6}>You currently have no templates created for this account</p>
						:null
					}
					{this.state.showSuccessPriceTemplateConfirmation?<SuccessPriceTemplateConfirmation saveTemplateOrNot={false} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null }
					{this.state.showGenericOverlayDialog?<GenericOverlayDialog buttons={this.state.modalButtons} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
					{this.state.showRunReportDialog?<RunReportDialog handleContinueRunReport={this.handleContinueRunReport.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
		      	</div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
	getSavedExports: (payload, callback) => dispatch(getSavedExports(payload, callback)),
	getSavedExportsForStandardTemplate: (payload, callback) => dispatch(getSavedExportsForStandardTemplate(payload, callback)),
	deletePriceTemplate: (payload, callback) => dispatch(deletePriceTemplate(payload, callback)),
	exportProducts: (payload, queryStringParams, callback) => dispatch(exportProducts(payload, queryStringParams, callback)),
	createPriceTemplate: (payload, callback) => dispatch(createPriceTemplate(payload, callback)),
	savePriceTemplates: (data) => dispatch(savePriceTemplates(data)),
	saveTemplateId: (data) => dispatch(saveTemplateId(data)),
	setEditTemplatePayload: (data) => dispatch(setEditTemplatePayload(data)),
	getMessages: (queryString, showLoader, callback) => dispatch(getMessages(queryString, showLoader, callback)),
});

SavedExports = connect(mapStateToProps, mapDispatchToProps)(SavedExports);
export default SavedExports;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Exports/savedExports.js